import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { memo } from 'react';
import { DisplayUeopt } from '../../../constants/enums';
import BadgeAvatar from '../../common/BadgeAvatar';
import FlexGrid from '../../common/FlexGrid';
import Name from '../../common/Name';
import Share from '../../common/Share';
import CounterViewers from '../CounterViewers';
import PreviewPosterImage from '../PreviewPosterImage';
import "./Header.linaria.module.css!=!./Header?./Header.linaria.module.css?css=H4sIAAAAAAAAA31Sy26kMBC85ytyWSl78AiYzCPmY5AxDTQY27KbDAnKv6+GGcAQaY9dXd2uLtdBUJcpyOLyNuhPOGzL0YqiQF2x3BCZjseJHdKflwfLZDBIuubbahkhY3l8Xvl1Ftdn0/Tf22oUCivNkKDzXIImcPcJHzd9c5GnsROuQj1tO9ohLdBbJb44aoUaWK6MbNPwyZMd0p3qEFJQ0gZwWNUPJBeyrZzpdcGkUcZxckJ7KxxomiRV1xixHQkGYpPqWW9pNDGP38DjQ+KgexyQXHTp5DgrZjfIWySWm/WKGSsVBGDnJyAkToQbFlRzKZR8i6Pozyt7vfv7N31aNJ12tUMavMSskC1vek9YfqXz5gfqrZDAcqAbgF6GnlwmjSbQtGP9v7v6EB0up6cR028fw6wsVfi5YVTccUnHb7Pn+EGGhS2r9221T2wUxDXkmz3/rmEhl3IT1rUc9wZsRclhvqwS25PkkJVUoUqmznVtfDQZqRYiNcreeeO4NRiu7NqsTrquOY/WeCQ0mjtQgvAT0p+Xf2Cz4eu/AwAA"
const rootGridStyles = "atm_le_1fwxnve atm_lo_exct8b atm_h_1h6ojuz";
const StyledShareImageDiv = /*#__PURE__*/styled('div')({
  name: "StyledShareImageDiv",
  class: "s1juj7c5",
  propsAsIs: false
});
const _exp7 = () => Name;
const StyledName = /*#__PURE__*/styled(_exp7())({
  name: "StyledName",
  class: "sg81iik",
  propsAsIs: true
});
const StyledViewersDiv = /*#__PURE__*/styled('div')({
  name: "StyledViewersDiv",
  class: "s127nfrc",
  propsAsIs: false
});
const infoStyles = "atm_h3_exct8b atm_r3_1h6ojuz";
const stylesNoPaddingTopBottom = "atm_le_idpfg4 atm_lo_idpfg4";
const stylesContent = "atm_fc_1h6ojuz atm_cx_exct8b";
const stylesGapSmall = "atm_cx_ftgil2";
const stylesBadgeAvatarCursor = "atm_9j_tlke0l";
const stylesFlexGridBadgeAvatar = "atm_mk_h2mmj6";
type HeaderProps = {
  onClickAvatar?(): void;
  onClickPreview?(): void;
  staticImage?: boolean;
  item?: boolean;
  small?: boolean;
  showInfo?: boolean;
  broadcasting: boolean;
  showViewers?: boolean;
  disableBadge?: boolean;
  displayMode?: DisplayUeopt;
  isMobile?: boolean;
  hasShare: boolean;
  viewers?: number;
  offline: boolean;
  is16x9: boolean;
  color?: string;
  rank?: number;
  slug: string;
  name: string;
  ssr?: boolean;
  id: number;
};
const Header = memo((props: HeaderProps) => {
  const {
    showInfo = true,
    onClickAvatar = () => {},
    onClickPreview = () => {},
    // sticky = true,
    disableBadge,
    broadcasting,
    showViewers,
    displayMode,
    staticImage,
    isMobile,
    hasShare,
    offline,
    viewers,
    small,
    color,
    slug,
    name,
    ssr,
    id
  } = props;
  const Core = <FlexGrid data-testid="RootHeader" className={cx(rootGridStyles, small && stylesNoPaddingTopBottom)}>
            <FlexGrid direction="row" wrap={small ? 'nowrap' : 'wrap'} className={cx(stylesContent, small && stylesGapSmall)}>
                {(!isMobile || displayMode !== DisplayUeopt.preview) && <FlexGrid className={stylesFlexGridBadgeAvatar}>
                        <BadgeAvatar onClick={onClickAvatar ?? onClickPreview} disableBadge={disableBadge} isBroadcasting={broadcasting} addBoxShadow={true} isOffline={offline} alt={name} size={small ? 81.5625 : 96} id={id} className={(onClickAvatar ?? onClickPreview) && stylesBadgeAvatarCursor} />
                    </FlexGrid>}
                {(!isMobile || displayMode === DisplayUeopt.preview) && <FlexGrid>
                        <PreviewPosterImage onClick={onClickPreview} id={id} height={!small ? 95.6256 : 81.5625} width={!small ? 170 : 145} ssr={ssr} staticImage={staticImage} rounded />
                        {showViewers && <StyledViewersDiv>
                                {typeof viewers === 'number' && !offline && <div data-testid="ProfileHeader__Viewers">
                                        <CounterViewers viewers={viewers} size={0.6} />
                                    </div>}
                            </StyledViewersDiv>}
                    </FlexGrid>}
            </FlexGrid>
            {showInfo && <FlexGrid className={infoStyles}>
                    <StyledName color={color} text={name} />
                    {hasShare && <StyledShareImageDiv>
                            <Share slug={slug} width={80} />
                        </StyledShareImageDiv>}
                </FlexGrid>}
        </FlexGrid>;
  return Core;
});
export default Header;